import { Enfant } from './Enfant';
import { NiveauRemboursement } from './NiveauRemboursement';

export class Personne {
  nom: string = '';
  prenom: string = '';
  sexe: string = ''; //1 femme 2 homme
  compositionFamiliale: string | null = '0'; // 1 = Celibataire, 2=Adulte avec Enfant, 3=Couple, 4= Couple avec enfant
  dateNaissanceAssure: string = '';
  lieuNaissance: string = '';
  paysNaissance: string = '';
  dateNaissanceConjoint: string = '';
  regimeSocial: string = '';
  conjointRegimeSociale: string = ''; //
  enfant: Enfant;
  dateDebutContrat: string = '';
  niveauRemboursement!: NiveauRemboursement | null;
  telephone: string = '';
  email: string = '';
  codeParrain: string = '';
  adresse1Parrain: string | null = '';
  adresse2Parrain: string | null = '';
  codePostal: string = '';
  etre_contacte_par_telephone: boolean = false;
  cspSouscripteur: string | null = '';
  cspConjointSouscripteur: string | null = '';

  constructor(
    nom: string,
    prenom: string,
    sexe: string,
    compositionFamiliale: string | null,
    dateNaissanceAssure: string,
    dateNaissanceConjoint: string,
    regimeSocial: string,
    conjointRegimeSociale: string,
    enfant: Enfant,
    dateDebutContrat: string,
    niveauRemboursement: NiveauRemboursement | null,
    telephone: string,
    email: string,
    codePostal: string,
    etre_contacte_par_telephone: boolean,
    codeParrain: string = '',
    adresse1Parrain: string | null = '',
    adresse2Parrain: string | null = '',
    cspSouscripteur: string | null = '',
    cspConjointSouscripteur: string | null = '',
  ) {
    this.nom = nom;
    this.prenom = prenom;
    this.sexe = sexe;
    this.compositionFamiliale = compositionFamiliale;
    this.dateNaissanceAssure = dateNaissanceAssure;
    this.dateNaissanceConjoint = dateNaissanceConjoint;
    this.regimeSocial = regimeSocial;
    this.conjointRegimeSociale = conjointRegimeSociale;
    this.enfant = enfant;
    this.dateDebutContrat = dateDebutContrat;
    this.niveauRemboursement = niveauRemboursement;
    this.telephone = telephone;
    this.email = email;
    this.codeParrain = codeParrain;
    this.adresse1Parrain = adresse1Parrain;
    this.adresse2Parrain = adresse2Parrain;
    this.codePostal = codePostal;
    this.etre_contacte_par_telephone = etre_contacte_par_telephone;
    this.cspSouscripteur = cspSouscripteur;
    this.cspConjointSouscripteur = cspConjointSouscripteur;
  }
}
